module.exports = __webpack_public_path__ + "static/media/icone-erroGeral-direcionar-atendimento.3cf63e71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icone-erroGeral-direcionar-atendimento.svg
// module id = 2789
// module chunks = 0